import BaseAddon from './baseAddon'
let appConfig = require('../../../config/index.js')

/***
 * 微信小程序插件类
 */
export default class wxMiniAddon extends BaseAddon {
  // 处理跳转
  handleRouterBeforeEach (to, from, next) {
    console.log('--handleRouterBeforeEach--', to.path)
    if (to.path === '/error') {
      return next()
    } else {
      let userInfo = global.myStore.get(global.myStore.staticName.USER_INFO)
      if (userInfo && userInfo.member_no) {
        next()
      } else {
        let state = global.browserQuery.state
        let memberNo = global.browserQuery.memberNo
        // 判断链接是否有memberNo
        if (memberNo) {
          global.myStore.set(global.myStore.staticName.USER_INFO, { member_no: memberNo })
          // let wxReg = appConfig.API_URL + '/#' + state
          let wxReg = '/#' + state
          location.replace(wxReg)
        } else {
          next('/error')
        }
      }
    }
  }
  /**
  * 获取用户信息集 (页面打开时候获取用户信息)
  */
  getInitUserInfo (that, obj) {
    let memberInfo = global.myStore.get(global.myStore.staticName.USER_INFO)
    if (!obj.isRefresh && memberInfo && memberInfo.id && memberInfo.member_mobile && memberInfo.member_mobile !== '----') {
      // 不刷新用户信息并存在用户信息
      that.$store.dispatch('updateUserInfo', memberInfo)
      return new Promise(function (resolve) {
        resolve(memberInfo)
      })
    }
    return global.tools.getMemberInfo(that, obj)
  }
}



// WEBPACK FOOTER //
// ./src/utils/tools/addon/wxMiniAddon.js